<template>
  <div id="term-begins">
    <div class="box">
      <div class="register-area">
        <div class="register">
          <span class="duration">活动时间：2019.09.10 —— 2019.10.31</span>
          <a href="https://account.mopaas.com/registerPublic.jsp">立即注册</a>
        </div>
      </div>
      <img src="../assets/images/biaoti01.png" />
      <div class="even-divide coupon">
        <a href="https://account.mopaas.com/web/user/user_purse.jsp"><img src="../assets/images/quan01.png" /></a>
        <a href="https://account.mopaas.com/web/user/user_purse.jsp"><img src="../assets/images/quan02.png" /></a>
        <a href="https://account.mopaas.com/web/user/user_purse.jsp"><img src="../assets/images/quan03.png" /></a>
        <a href="https://account.mopaas.com/web/user/user_purse.jsp"><img src="../assets/images/quan04.png" /></a>
      </div>
      <img src="../assets/images/biaoti02.png" />
      <div class="research">
        <img src="../assets/images/erweima.png" />
        <div class="bg">
          <p>
            凡认真填写问卷者，均免费赠送10元MoPaaS体验金。
            问卷选项可多选，填写问卷的时候需正确填写电话、邮箱以及MoPaaS账户用户名，以便体验金顺利到账。
            <a href="http://mopaashr.mikecrm.com/pnA60Zy" target="_blank">我要查看调研问卷</a></p>
        </div>
      </div>
      <img src="../assets/images/biaoti03.png" />
      <div class="scene">
        <div class="item" v-for="item in scenes" :key="item.id">
          <div class="inner">
            <div class="icon-bg"><img class="icon" :src="item.icon" /></div>
            <h3>{{item.title}}</h3>
            <p>{{item.content}}</p>
          </div>
        </div>
      </div>
      <img src="../assets/images/biaoti04.png" />
      <div class="rule">
        <div class="inner">
          <p>
            1.本规则适用于在线充值用户；
            2.满送仅限于单个订单额度，同一账户不同订单金额不叠加计算；
            3.同一账户不同订单情况下，凡单个订单满足条件的均可享受满送福利；
            4.订单在活动时间范围内完成支付才能享受活动优惠，逾期支付则不享受活动优惠；
            5.所有参加本活动的用户，均视为认可并同意遵守<router-link to="/more/terms-of-service">《MoPaaS用户协议》</router-link>。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TermBegins',
    data() {
      return {
        scenes: [{
          id: 0,
          icon: require('@/assets/images/scene1.png'),
          title: '原型托管',
          content: '轻量级的静态页面类型的应用托管，为您的产品原型提供在线更新、发布和管理能力'
        }, {
          id: 1,
          icon: require('@/assets/images/scene2.png'),
          title: '静态网页',
          content: '以最小的成本实现静态网站的建站工作，省钱省心'
        }, {
          id: 2,
          icon: require('@/assets/images/scene3.png'),
          title: '中小企业门户',
          content: '满足中小型企业的门户网站支撑能力，提供常见的开发语言和数据库类型支持'
        }, {
          id: 3,
          icon: require('@/assets/images/scene4.png'),
          title: '中小企业应用',
          content: '企业级应用托管，支持常见语言的运行环境，支持多种数据库类型和持久化存储'
        }, {
          id: 4,
          icon: require('@/assets/images/scene5.png'),
          title: '移动应用后台',
          content: '满足APP、小程序等移动应用后台管理系统的托管需求，提供完整的底层服务和自动化运维能力'
        }]
      }
    }
  }
</script>

<style>
  #term-begins {
    height: 3150px;
    overflow-y: hidden;
    background-image: url(../assets/images/term-begins-bg.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  #term-begins .box {
    margin-top: 1097px;
    width: 1143px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  #term-begins .register-area {
    width: 100%;
    height: 89px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: linear-gradient(214deg, rgba(29, 6, 136, 1), rgba(80, 46, 238, 1), rgba(29, 6, 136, 1));
    border: 1px solid rgba(30, 1, 164, 1);
    /* opacity: 0.6; */
  }

  #term-begins .register-area .register {
    width: 100%;
    height: 100%;
    background-image: url(../assets/images/xinren.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  #term-begins .register-area .register .duration {
    /* width: 316px; */
    margin-right: 30px;
    height: 19px;
    font-size: 20px;
    font-family: SimHei;
    font-weight: 400;
    color: rgba(184, 146, 1, 1);
  }

  #term-begins .register-area .register>a {
    font-size: 22px;
    font-family: SimHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
    width: 146px;
    height: 59px;
    background: linear-gradient(0deg, rgba(0, 172, 180, .8), rgba(0, 235, 246, .8), rgba(0, 244, 255, .8), rgba(0, 235, 246, .8));
  }

  #term-begins .box>img {
    margin-top: 120px;
  }

  #term-begins .box .even-divide {
    display: flex;
    justify-content: space-between;
  }

  #term-begins .box .coupon {
    margin-top: 100px;
    width: 1100px;
  }

  #term-begins .box .research {
    margin-top: 99px;
    width: 1080px;
    height: 123px;
    display: flex;
    justify-content: flex-start;
  }

  #term-begins .box .research img {
    width: 123px;
    margin-right: 23px;
  }

  #term-begins .box .research .bg {
    width: 934px;
    background-color: #0F4BB7;
  }

  #term-begins .box .research .bg p {
    margin-left: -20px;
    font-size: 16px;
    font-family: SimHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    white-space: pre-wrap;
    text-align: left;
    line-height: 1.5;
  }

  #term-begins .box .research .bg p a {
    color: #F5D043;
    text-decoration: underline;
  }

  #term-begins .box .scene {
    margin-top: 82px;
    width: 1142px;
    height: 280px;
    display: flex;
    justify-content: space-between;
  }

  #term-begins .box .scene .item {
    width: 210px;
    height: 280px;
    background: rgba(15, 75, 183, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #term-begins .box .scene .item .inner {
    width: 181px;
    height: 251px;
    border: 1px dashed rgba(0, 156, 236, 1);
    /* opacity: 0.45; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  #term-begins .box .scene .item .inner .icon-bg {
    margin-top: 22px;
    width: 66px;
    height: 66px;
    border-radius: 50%;
    background-color: rgba(0, 156, 236, .45);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #term-begins .box .scene .item .inner h3 {
    margin-top: 24px;
    font-size: 14px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #fff;
  }

  #term-begins .box .scene .item .inner p {
    margin-top: 21px;
    width: 131px;
    font-size: 12px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
    line-height: 1.5;
    text-align: left;
  }

  #term-begins .box .rule {
    margin-top: 50px;
    width: 1143px;
    height: 212px;
    background: rgba(15, 75, 183, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #term-begins .box .rule .inner {
    width: 1116px;
    height: 184px;
    border: 1px dashed rgba(40, 109, 232, 1);
  }

  #term-begins .box .rule p {
    margin: -10px 0 0 -20px;
    font-size: 14px;
    font-family: SimHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 2;
    text-align: left;
    white-space: pre-wrap;
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/TermBegins.vue